export default __webpack_public_path__ + "static/media/csc-horizontal.eb954316.svg";